module.exports = __webpack_public_path__ + "static/img/032电力公司使用手册.9fda35e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/032电力公司使用手册.jpg
// module id = hep1
// module chunks = 0